<template>
  <nav class="sidebar-main" id="sidebar-main">
    <li class="left-arrow"
      :class="{ 'd-none': layout.settings.layout_type == 'rtl' ? hideLeftArrowRTL : hideLeftArrow }"
      @click="(String(layoutobject || '').split(' ').includes('horizontal-wrapper') && layout.settings.layout_type === 'rtl') ? scrollToLeftRTL() : scrollToLeft()">
      <vue-feather type="arrow-left"></vue-feather>
    </li>
    <Navmenu />
    <li class="right-arrow"
      :class="{ 'd-none': layout.settings.layout_type == 'rtl' ? hideRightArrowRTL : hideRightArrow }"
      @click="(layoutobject == 'horizontal_sidebar' && layout.settings.layout_type == 'rtl') ? scrollToRightRTL() : scrollToRight()">
      <vue-feather type="arrow-right"></vue-feather>
    </li>
  </nav>
</template>

<script>
import { storeToRefs } from 'pinia';
import { useMenuStore } from '@/stores/menu';
import { useLayoutStore } from '@/stores/layout';
import { layoutClasses } from '../../constants/layout';
import Navmenu from './navmenu.vue';

export default {
  name: 'Nav',
  components: {
    Navmenu
  },
  data() {
    return {
      layoutobj: {}
    };
  },
  setup() {
    const menuStore = useMenuStore();
    const layoutStore = useLayoutStore();
    const { data, hideRightArrowRTL, hideLeftArrowRTL, hideRightArrow, hideLeftArrow, width, height, margin, menuWidth } = storeToRefs(menuStore);
    const { layout } = storeToRefs(layoutStore);
    return {
      menuStore,
      layoutStore,
      layout,
      menuData: data,
      hideRightArrowRTL,
      hideLeftArrowRTL,
      hideRightArrow,
      hideLeftArrow,
      width,
      height,
      margin,
      menuWidth,
    };
  },
  computed: {
    layoutobject: {
      get: function () {
        return JSON.parse(JSON.stringify(layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout)))[this.layout.settings.layout];
      },
      set: function () {
        this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout];
        return this.layoutobj;
      }
    }
  },
  watch: {
    layoutobject() {
      setTimeout(() => {
        const elmnt = document.getElementById('myDIV');
        this.menuStore.menuWidth = elmnt.offsetWidth;
      }, 500);
    }
  },
  methods: {
    scrollToRightRTL() {
      this.temp = this.menuStore.width + this.menuStore.margin;
      // Checking condition for remaing margin
      if (this.temp === 0) {
        this.menuStore.margin = this.temp;
        this.menuStore.hideRightArrowRTL = false;
      } else {
        this.menuStore.margin += this.menuStore.width;
        this.menuStore.hideRightArrowRTL = false;
        this.menuStore.hideLeftArrowRTL = false;
      }
    },
    scrollToLeftRTL() {
      // If Margin is reach between screen resolution
      if (this.menuStore.margin <= -this.menuStore.width) {
        this.menuStore.margin += -this.menuStore.width;
        this.menuStore.hideLeftArrowRTL = true;
      } else {
        this.menuStore.margin += -this.menuStore.width;
        this.menuStore.hideRightArrowRTL = false;
        this.menuStore.activeoverlay = false;
      }
    },
    scrollToLeft() {
      // If Margin is reach between screen resolution
      if (this.menuStore.margin >= -this.menuStore.width) {
        this.menuStore.margin = 0;
        this.menuStore.hideLeftArrow = true;
      } else {
        this.menuStore.margin += this.menuStore.width;
        this.menuStore.hideRightArrow = false;
      }
    },
    scrollToRight() {
      // Compute using menuWidth + width
      this.temp = this.menuStore.menuWidth + this.menuStore.width;
      // Checking condition for remaining margin
      if (this.temp > this.menuStore.menuWidth) {
        this.menuStore.margin = -this.temp;
        this.menuStore.hideRightArrow = true;
      } else {
        this.menuStore.margin += -this.menuStore.width;
        this.menuStore.hideLeftArrow = false;
      }
    }
  }
};
</script>
